import { graphql, useStaticQuery } from "gatsby"

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      image: allFile(filter: {name: {eq: "logo"}, extension: {eq: "png"}}) {
        edges {
          node {
            id
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      site {
        siteMetadata {
          title
          description
          twitterUsername
          siteUrl
        }

      }

    }
  `)

  return data
}